import { HttpRequestEntity, HttpRequestModelType } from 'shared/domain/httpRequest/httpRequestModel';
import type { WorkflowStageOutDto } from 'shared/domain/workflow/types';
import {
  broadcastCreatedStage,
  broadcastUpdatedStage,
  broadcastDeletedStage,
  broadcastReorderedStage,
} from 'serviceWorker/broadcasts/workflow/one';
import { broadcastStageError } from 'serviceWorker/broadcasts/workflow/error';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import { neverReached } from 'shared/utils/neverReached';

export function broadcastStageResponse(
  request: HttpRequestEntity,
  response: WorkflowStageOutDto | { error: unknown }
): void {
  if ('error' in response && response.error) {
    return broadcastStageError(response.error, request.data.uniqueId, chooseErrorMessage(response.error));
  }

  if (request.entityType === HttpRequestModelType.workflowStageReorder) {
    return broadcastReorderedStage(response as WorkflowStageOutDto, request.data.uniqueId);
  }

  switch (request.method) {
    case 'POST':
      return broadcastCreatedStage(response as WorkflowStageOutDto, request.data.uniqueId);
    case 'PUT':
      return broadcastUpdatedStage(response as WorkflowStageOutDto, request.data.uniqueId);
    case 'DELETE':
      return broadcastDeletedStage(response as WorkflowStageOutDto, request.data.uniqueId);
    case 'GET':
      return broadcastStageError(
        new Error('GET method not supported for stage'),
        request.data.uniqueId
      );
    default:
      neverReached(request.method);
  }
}
